// import React, { useState } from "react";
// import axios from "axios";
// import contact2 from "../../assets/about/Contact-Us.jpeg";
// import Popup from "../common/Popup";
// import BASE_URL from "../../config/config";
// import { Link } from "react-router-dom";

// const GetInTouchForm = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     company: "",
//     phone: "",
//     message: "",
//     consent: false,
//   });

//   const [errors, setErrors] = useState({});
//   const [showPopup, setShowPopup] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const validate = () => {
//     const newErrors = {};

//     const nameRegex = /^[A-Za-z ]+$/;
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     const phoneRegex = /^[0-9]{10}$/;

//     if (!formData.name || !nameRegex.test(formData.name)) {
//       newErrors.name = "Please enter a valid name (letters only).";
//     }

//     if (!formData.email || !emailRegex.test(formData.email)) {
//       newErrors.email = "Please enter a valid email address.";
//     }

//     if (!formData.company) {
//       newErrors.company = "Please enter your company name.";
//     }

//     if (!formData.phone || !phoneRegex.test(formData.phone)) {
//       newErrors.phone = "Please enter a valid 10-digit phone number.";
//     }

//     if (!formData.message || formData.message.length < 10) {
//       newErrors.message = "Message must be at least 10 characters.";
//     }

//     if (!formData.consent) {
//       newErrors.consent =
//         "Please accept the Terms & Conditions and Privacy Policy.";
//     }

//     setErrors(newErrors);

//     return Object.keys(newErrors).length === 0;
//   };

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;

//     setFormData({
//       ...formData,
//       [name]: type === "checkbox" ? checked : value,
//     });

//     setErrors({
//       ...errors,
//       [name]: "",
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validate()) return;

//     setLoading(true);

//     try {
//       const response = await axios.post(`${BASE_URL}/users/enquiry`, formData);

//       if (response.status === 200) {
//         setFormData({
//           name: "",
//           email: "",
//           company: "",
//           phone: "",
//           message: "",
//           consent: false,
//         });

//         setErrors({});
//         setShowPopup(true);

//         setTimeout(() => {
//           setShowPopup(false);
//         }, 3000);
//       }
//     } catch (error) {
//       console.error("Error submitting enquiry:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       {showPopup && (
//         <Popup
//           message="Thanks! Your message was sent successfully."
//           onClose={() => setShowPopup(false)}
//         />
//       )}

//       <div className="min-h-screen flex flex-col items-center justify-center p-4">
//         <div className="text-center">
//           <h2 className="text-2xl md:text-4xl font-bold text-gray-800">
//             Request Demo
//           </h2>

//           <div className="w-24 h-1 md:mb-0 mb-2 bg-main mx-auto rounded"></div>
//         </div>

//         <div className="w-full max-w-6xl overflow-hidden gap-10 flex flex-col lg:flex-row">
//           <div className="lg:w-1/2 w-full lg:h-auto">
//             <img
//               src={contact2}
//               alt="Contact"
//               className="w-full h-full object-contain object-center"
//             />
//           </div>

//           <div className="lg:w-1/2 w-full p-1 sm:p-10 lg:p-12">
//             <h2 className="md:text-3xl text-xl font-bold text-gray-800 mb-6 text-center border-b-2 border-gray-300 pb-2">
//               Get In Touch
//             </h2>

//             <p className="text-gray-600 mb-6 text-center">
//               Fill out the form below and we’ll get back to you shortly.
//             </p>

//             <form className="space-y-4" onSubmit={handleSubmit}>
//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                 <div>
//                   <input
//                     type="text"
//                     name="name"
//                     placeholder="Your Name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-main"
//                   />

//                   {errors.name && (
//                     <p className="text-red-500 text-sm mt-1">{errors.name}</p>
//                   )}
//                 </div>

//                 <div>
//                   <input
//                     type="email"
//                     name="email"
//                     placeholder="Your Email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-main"
//                   />

//                   {errors.email && (
//                     <p className="text-red-500 text-sm mt-1">{errors.email}</p>
//                   )}
//                 </div>
//               </div>

//               <div>
//                 <input
//                   type="text"
//                   name="company"
//                   placeholder="Company Name"
//                   value={formData.company}
//                   onChange={handleChange}
//                   className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-main"
//                 />

//                 {errors.company && (
//                   <p className="text-red-500 text-sm mt-1">{errors.company}</p>
//                 )}
//               </div>

//               <div>
//                 <input
//                   type="tel"
//                   name="phone"
//                   placeholder="Phone Number"
//                   value={formData.phone}
//                   onChange={handleChange}
//                   className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-main"
//                 />

//                 {errors.phone && (
//                   <p className="text-red-500 text-sm mt-1">{errors.phone}</p>
//                 )}
//               </div>

//               <div>
//                 <textarea
//                   name="message"
//                   rows="4"
//                   placeholder="Your Message"
//                   value={formData.message}
//                   onChange={handleChange}
//                   className="w-full px-4 pt-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-main resize-none"
//                 />

//                 {errors.message && (
//                   <p className="text-red-500 text-sm mt-1">{errors.message}</p>
//                 )}
//               </div>

//               {/* Consent Checkbox */}
//               <div>
//                 <label className="flex items-start gap-3 cursor-pointer">
//                   <input
//                     type="checkbox"
//                     name="consent"
//                     checked={formData.consent}
//                     onChange={handleChange}
//                     className="mt-1 h-4 w-4 accent-main"
//                   />

//                   <span className="text-xs text-gray-700 leading-4">
//                     I agree to the{" "}
//                     <Link
//                       to="/terms-and-conditions"
//                       className="font-semibold text-blue-600 hover:underline"
//                     >
//                       Terms & Conditions
//                     </Link>{" "}
//                     and{" "}
//                     <Link
//                       to="/privacy-policy"
//                       className="font-semibold text-blue-600 hover:underline"
//                     >
//                       Privacy Policy
//                     </Link>{" "}
//                     and consent to receive communications from{" "}
//                     <span className="font-semibold">
//                       Deetya Soft Private Limited
//                     </span>{" "}
//                     via SMS, Email, Calls, RCS Messages, and WhatsApp.
//                   </span>
//                 </label>

//                 {errors.consent && (
//                   <p className="text-red-500 text-sm mt-[1px]">{errors.consent}</p>
//                 )}
//               </div>

//               <button
//                 type="submit"
//                 className="w-full bg-main text-white py-3 rounded-xl font-semibold transition duration-300 disabled:opacity-70"
//                 disabled={loading}
//               >
//                 {loading ? "Submitting..." : "Send Message"}
//               </button>
//             </form>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default GetInTouchForm;








import React, { useState } from "react";
import contact2 from "../../assets/about/Contact-Us.jpeg";
import Popup from "../common/Popup";
import BASE_URL from "../../config/config";
import { Link } from "react-router-dom";

const GetInTouchForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    phone: "",
    message: "",
    consent: false,
  });

  const [errors, setErrors] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const newErrors = {};

    const nameRegex = /^[A-Za-z ]+$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/;

    if (!formData.name || !nameRegex.test(formData.name)) {
      newErrors.name = "Please enter a valid name (letters only).";
    }

    if (!formData.email || !emailRegex.test(formData.email)) {
      newErrors.email = "Please enter a valid email address.";
    }

    if (!formData.company) {
      newErrors.company = "Please enter your company name.";
    }

    if (!formData.phone || !phoneRegex.test(formData.phone)) {
      newErrors.phone = "Please enter a valid 10-digit phone number.";
    }

    if (!formData.message || formData.message.length < 10) {
      newErrors.message = "Message must be at least 10 characters.";
    }

    if (!formData.consent) {
      newErrors.consent =
        "Please accept the Terms & Conditions and Privacy Policy.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });

    setErrors({
      ...errors,
      [name]: "",
    });
  };

  // Helper to safely get response body (JSON or plain text)
  const getResponseBody = async (response) => {
    const contentType = response.headers.get("content-type") || "";
    const text = await response.text(); // always read as text first
    if (contentType.includes("application/json")) {
      try {
        return JSON.parse(text);
      } catch {
        return text; // fallback if JSON parse fails
      }
    }
    return text; // plain text
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);

    // ---- Payload for first API (dndfilter) ----
    const payload1 = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      message: formData.message,
      agreements: formData.consent,
    };

    // ---- Payload for second API (apilms) ----
    const payload2 = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      comment: formData.message,
      address: formData.company, // company name as address
      projectName: "Deetyasoft.com", // Fixed project name
    };

    console.log("📦 Payload 1:", payload1);
    console.log("📦 Payload 2:", payload2);

    try {
      const [response1, response2] = await Promise.all([
        fetch(`${BASE_URL}/users/enquiry`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload1),
        }),
        fetch("https://apilms.deetyasoft.com/api/publicLeads", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-API-KEY": "Uqecpr4T5iUUYK9",
          },
          body: JSON.stringify(payload2),
        }),
      ]);

      // Parse both responses safely
      const [data1, data2] = await Promise.all([
        getResponseBody(response1),
        getResponseBody(response2),
      ]);

      console.log("✅ First API Response:", data1);
      console.log("✅ Second API Status:", response2.status, response2.statusText);
      console.log("✅ Second API Response Body:", data2);

      // Check if both succeeded
      if (!response1.ok || !response2.ok) {
        throw new Error(
          `API failure: First=${response1.status}, Second=${response2.status}`
        );
      }

      // Success
      setFormData({
        name: "",
        email: "",
        company: "",
        phone: "",
        message: "",
        consent: false,
      });

      setErrors({});
      setShowPopup(true);

      setTimeout(() => {
        setShowPopup(false);
      }, 3000);

    } catch (error) {
      console.error("❌ Error submitting enquiry:", error);
      // You might want to show an error popup here
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {showPopup && (
        <Popup
          message="Thanks! Your message was sent successfully."
          onClose={() => setShowPopup(false)}
        />
      )}

      <div className="min-h-screen flex flex-col items-center justify-center p-4">
        <div className="text-center">
          <h2 className="text-2xl md:text-4xl font-bold text-gray-800">
            Request Demo
          </h2>

          <div className="w-24 h-1 md:mb-0 mb-2 bg-main mx-auto rounded"></div>
        </div>

        <div className="w-full max-w-6xl overflow-hidden gap-10 flex flex-col lg:flex-row">
          <div className="lg:w-1/2 w-full lg:h-auto">
            <img
              src={contact2}
              alt="Contact"
              className="w-full h-full object-contain object-center"
            />
          </div>

          <div className="lg:w-1/2 w-full p-1 sm:p-10 lg:p-12">
            <h2 className="md:text-3xl text-xl font-bold text-gray-800 mb-6 text-center border-b-2 border-gray-300 pb-2">
              Get In Touch
            </h2>

            <p className="text-gray-600 mb-6 text-center">
              Fill out the form below and we'll get back to you shortly.
            </p>

            <form className="space-y-4" onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-main"
                  />

                  {errors.name && (
                    <p className="text-red-500 text-sm mt-1">{errors.name}</p>
                  )}
                </div>

                <div>
                  <input
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-main"
                  />

                  {errors.email && (
                    <p className="text-red-500 text-sm mt-1">{errors.email}</p>
                  )}
                </div>
              </div>

              <div>
                <input
                  type="text"
                  name="company"
                  placeholder="Company Name"
                  value={formData.company}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-main"
                />

                {errors.company && (
                  <p className="text-red-500 text-sm mt-1">{errors.company}</p>
                )}
              </div>

              <div>
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-main"
                />

                {errors.phone && (
                  <p className="text-red-500 text-sm mt-1">{errors.phone}</p>
                )}
              </div>

              <div>
                <textarea
                  name="message"
                  rows="4"
                  placeholder="Your Message"
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full px-4 pt-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-main resize-none"
                />

                {errors.message && (
                  <p className="text-red-500 text-sm mt-1">{errors.message}</p>
                )}
              </div>

              {/* Consent Checkbox */}
              <div>
                <label className="flex items-start gap-3 cursor-pointer">
                  <input
                    type="checkbox"
                    name="consent"
                    checked={formData.consent}
                    onChange={handleChange}
                    className="mt-1 h-4 w-4 accent-main"
                  />

                  <span className="text-xs text-gray-700 leading-4">
                    I agree to the{" "}
                    <Link
                      to="/terms-and-conditions"
                      className="font-semibold text-blue-600 hover:underline"
                    >
                      Terms & Conditions
                    </Link>{" "}
                    and{" "}
                    <Link
                      to="/privacy-policy"
                      className="font-semibold text-blue-600 hover:underline"
                    >
                      Privacy Policy
                    </Link>{" "}
                    and consent to receive communications from{" "}
                    <span className="font-semibold">
                      Deetya Soft Private Limited
                    </span>{" "}
                    via SMS, Email, Calls, RCS Messages, and WhatsApp.
                  </span>
                </label>

                {errors.consent && (
                  <p className="text-red-500 text-sm mt-[1px]">{errors.consent}</p>
                )}
              </div>

              <button
                type="submit"
                className="w-full bg-main text-white py-3 rounded-xl font-semibold transition duration-300 disabled:opacity-70"
                disabled={loading}
              >
                {loading ? "Submitting..." : "Send Message"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default GetInTouchForm;